module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Sunset Promises")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781488079085.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("CHAPTER ONE")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_vm._v("The pains began the moment her plane touched down at the Cheyenne, Wyoming, airport. By the time she got into the back of the cab to carry her to the Connor ranch, the pains shot through her with a regularity that terrified her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lady, are you okay?” The driver frowned at her in his rearview mirror. “You ain’t gonna have that baby right here in my cab, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I certainly hope not.” She rubbed her protruding stomach and drew in a deep breath. “How much farther to the Connor ranch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not far, just over the next hill.” As if sensing her imminent delivery, the driver stepped on the gas, encouraging the old car to go faster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She leaned her head against the seat, willing herself to try to relax, drawing air deep into her lungs. The pain battled with fear, the fear that had ridden her like a demon since that morning she’d awakened in a hotel room in Las Vegas.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Shivering, she remembered that moment when sleep had fallen away and she’d sat up in the bed, not knowing where she was or how she had gotten there. ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("More frightening was the realization that she had no idea who she was, only that she was very pregnant and had no memory of anything beyond that moment in time.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A purse lying on the end of the bed had held the answer to who she was. The driver’s license inside had displayed a photo of her with the name of Colette Connor. Unfortunately, the license hadn’t answered many other questions, like how she had come to be in the hotel room and whose baby she carried.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A suitcase had yielded clothes, an envelope of money and letters written to her and mailed from a ranch in Wyoming. The ranch was the same address as the one on her driver’s license. Not knowing what else to do, Colette had hopped a plane to Cheyenne, hoping she would find welcome and answers at the Connor ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the driver turned off onto a dirt road, Colette grabbed her stomach and swallowed a moan as another pain ripped through her. Tears blurred her vision as she rode the wave of pain, vaguely aware of the taxi driver’s frantic muttered curse from the front seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hang tight, missy,” the driver exclaimed, pulling her back to the present. “The Connor ranch is just ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colette sat up straighter, hoping the landscape would jog her errant memory. A flat plain of scrub grass stretched out seemingly endless. The only break in the monotony was buttes of rock jutting upward and the distant foothills of a mountain range.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Nothing. No sudden flash of insight, no burst of released memories. Nothing. Dammit, what had happened to her to steal her memories? Why couldn’t she ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("tear aside the black curtain that obscured her own identity?")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver turned onto another dirt road, then crested a hill. “There it is,” he said, pointing to the ranch spread out in the valley just at the foot of the hills.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was this home? Colette wondered, fighting against another contraction, this one stealing her breath away. Would she find family here? Somebody who could fill in all the blank spaces in her mind? Would she find a man waiting for her, frantic with worry? She wore no wedding or engagement ring but that didn’t mean there wasn’t a special someone in her life. So where was he now? Why was she alone?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They crossed beneath a wooden sign announcing Welcome and the driver passed a number of outbuildings and corrals before pulling to a stop in front of a sprawling ranch house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver, obviously eager to be rid of her, hurried from his seat and unloaded her suitcase from the trunk. Colette didn’t move. Despite the viselike contraction that squeezed her, the physical pain couldn’t touch the fear that riveted through her as she stared at the unfamiliar house. What if she wasn’t welcome here? Maybe her family had disowned her, thrown her from the house months before. What if there was nobody here who would help her?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("She jumped as a tall blond woman walked out of the house, a smile of welcome on her lips as she approached the taxi. Colette’s heart beat rapidly as an odd familiarity whispered through her. She opened the door and with an effort stepped out. Leaning ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("against the cab, she wrapped her arms around her burgeoning stomach as another pain stabbed through her.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The smile of welcome fell from the woman’s lips, replaced by shocked recognition. “Colette? Oh, my God.” She raced to Colette’s side and placed an arm around her. With a single glance she assessed the situation. “Cody,” she yelled to the little boy lingering on the porch, “run and get Doctor Washburn. Tell him Aunt Colette is home and it appears she’s about to deliver a baby.” Without hesitation he took off running toward one of the outbuildings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please…help me,” Colette whispered weakly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shh, of course we’re going to help you.” The woman’s arms offered additional feelings of familiarity, and Colette knew whoever she was, she was somebody important in Colette’s life. “Bulldog,” the woman yelled. A tall, thickset young man rounded the side of the house, his moon-shaped face unlined save a vacant smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby, can I help?” The deep masculine voice came from one side of Colette. She turned her head to see a tall, raven-haired cowboy. A faint coating of dust and dark stubble covered well-defined features. Somehow Colette knew with a certainty that beneath his five o’clock shadow hid a dimple in his chin. A black wide-brimmed hat obscured his eyes, but as he reached out a hand and touched the swell of her belly, she hissed inwardly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Her breath caught in her throat and for just a moment she felt as though she’d run right into the arms of danger—she hadn’t escaped. The thought was alien, nonsensical and quickly swallowed by another ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("crashing wave of contraction that nearly bent her double.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think we can handle it,” Abby said to the cowboy. “Bulldog, please carry Colette up to her room. And, Bulldog…be gentle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, ma’am, Ms. Abby.” With the ease of Hercules, the round-faced man called Bulldog swept Colette up into his arms. As he carried her to the front door, she was vaguely aware of Abby paying the cabdriver and sending him on his way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked over Bulldog’s shoulder, seeking the cowboy who’d startled her, but he was nowhere to be found, making her wonder if he’d been a figment of her pain-crazed mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The names—Abby, Cody, Bulldog—all rang distant chords of memory, and Colette felt if she could just have a moment without the pains she could pull it all together, remember everything. But the pain was constant, feeling as if it would rip her apart, tear her asunder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Bulldog gently placed her on the bed in a small bedroom, she felt all rational thought dissipate beneath the overriding torment of giving birth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her body was beyond her control, as was her mind, and she gave herself up to the primal instinct of survival.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("It didn’t take her long to lose track of time. The pains came one after another and despite the fact that Dr. Washburn kept assuring her she was doing fine, she feared she would die. The thought of dying without knowing who she was, who the baby’s father was, why she couldn’t remember, caused her to hold tight to Abby’s hand. Through her moans, she tried to tell ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Abby about her confusion, but knew she wasn’t making sense.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Push, Colette,” Abby coached. “Come on, you can do it. Push.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The words echoed in Colette’s mind. Instantly a splintered memory filled her head….")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Push, Colette. Come on, Belinda and I can’t do it all alone.” The wagon was heavy, laden with treasures and goodies for a picnic beneath the dragon tree. Belinda and Abby were pulling and Colette was at the rear to push the wagon up the hill. But whenever her sisters weren’t looking, Colette sat on the edge of the wagon, getting a brief ride until one of them turned around and yelled at her once again.")])]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CAN SEE")]), _vm._v(" the head. Come on, honey. Just a little bit more,” Abby encouraged, and as she had so many years before, Colette did what her big sister bid. She drew in a deep breath, then bore down, screaming in relief as Abby shouted triumphantly and the baby cried a lusty hello to the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a girl,” Abby exclaimed, tears glistening in her eyes as she wiped Colette’s forehead with a damp cloth. “Oh, Colette, you did a terrific job and you’ve got a beautiful daughter.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The doctor placed the tiny child in a blanket that smelled of sunshine and fresh air and laid her in the crook of Colette’s arms. Euphoric joy suffused Colette as she looked at the child…her daughter. A wealth of dark hair covered the little head, and solemn deep blue eyes regarded Colette in an expression something between wisdom and amusement. It was ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("as if the child, in the moments after birth, possessed all the answers of the universe.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With a yawn the baby nestled against the warmth of Colette’s body and closed her eyes. Fierce protectiveness welled up inside Colette and she stroked the tiny face with a gentle finger. This baby, this child, had no name and no memories, born to a mother who had no recollection of her own past. She stared at the little face, wondering if the baby resembled her daddy. Oh, God, where was the father? Why hadn’t he been with her? Who was he? Why couldn’t she remember?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tears burned hot and she blinked them away, refusing to give in to the despair that clawed at her insides. She needed answers. More importantly, she needed to find out why she felt as if she were running from something…or someone.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMN HER")]), _vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hank Cooper would have given anything to unleash the most vulgar string of curse words his twisted mind could create, but instead he sank onto a bench outside the barn. The late afternoon sun washed his back and shoulders with a balmy warmth. He half smiled sardonically, too bad the warmth would never penetrate into his soul. He’d thought she might come back here, back to her roots, back to the ranch. He was rarely wrong.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("He swept his hat off his head and slapped it against his knee, his thoughts whirling like dust across the prairie. He didn’t think she’d recognized him, but he knew better than to trust her. Still, he’d seen no recognition in her eyes, not even when he’d touched her. ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("He clenched his hand, trying not to think of that moment when his hand had gently touched her stomach.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d been shocked when he’d seen her get out of the taxi, her stomach protruded, her features twisted in pain. Although he’d known she was pregnant, the reality of her physical condition hadn’t hit him until he’d seen her ready to give birth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Hank.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hank looked up to see Bulldog, his round face decorated with his usual friendly smile. Hank nodded curtly, not particularly interested in company.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bulldog sat next to Hank, the bench creaking beneath his sturdy weight. “Want one?” he asked, holding out a handful of peppermint candy. Hank shook his head. Bulldog popped several pieces into his mouth. “Colette came home,” he said, sending toward Hank the sweet scent of the candy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s been gone a long time. I missed her.” The tips of Bulldog’s ears reddened slightly. “I always thought she was so pretty. She had a baby.” His smile transformed into a scowl. “I hope some man didn’t wrong her. I’d kill anyone who hurt Colette.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("And I won’t let anyone get in my way,")]), _vm._v(" Hank thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure you don’t want one?” Bulldog offered the candy again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I gotta get back to work.” Bulldog stood and smiled. The gesture lit up his moonlike face, added depth to his rather vacant gaze. “It’s gonna be nice around here with Colette back and a new baby in the house. Yes, sir, things are gonna be just fine.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("With a tuneless whistle, Bulldog waved, then strode off.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hank watched the big man until he disappeared into the barn, then he turned his attention to the house. His hands clenched at his sides as he thought of how Colette had gotten away from him, sneaking away like a thief in the night. It amazed him that she’d honestly believed she could elude him, that he would let her slink away and forget about everything. If she thought he would just let her go, she was sadly mistaken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His gaze sought the window of her bedroom. White curtains moved in the slight breeze but no sound drifted from the interior. Colette. And now a baby. Another problem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Consciously he took a deep breath. That was all behind him now. She was here and he wasn’t about to lose track of her again.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('i', [_vm._v("A "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAND STROKING HER")]), _vm._v(", creating flames of delight as it touched her, caressed her. The hand was achingly familiar…a lover’s hand and Colette knew it belonged to the man she loved, her baby’s father. She struggled to open her eyes, wanting to see him, but her eyelids were too heavy. She touched his face, feeling bold features, sensual lips, the small indention in his chin.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Suddenly the hands no longer stroked, but rather imprisoned, exerting painful pressure. Fear choked her throat as she struggled to get free. “Help me,” she cried.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Come on, Colette, you can do it,” Abby’s voice came from far away.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('i', [_vm._v("“Please help me,” Colette screamed. The pressure disappeared and she sobbed in relief. As she brought her hands up to her face, she saw the blood. Her hands were covered with blood.")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With a gasp, Colette woke up. The golden light of dusk painted the room and the baby was snuggled in her arms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A dream,” she murmured, trying to dismiss the disturbing sleep visions. Still, the fear surged upward, leaving a foul taste in her mouth as she wondered where she’d been, what she’d done. According to her license, she was twenty-two years old. Her life consisted of nothing more than a name, an age and an abiding fear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She started as the door to the bedroom cracked open, then relaxed as Abby stuck her head in. “Oh, good. You’re awake. How do you feel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tired mixed with a million other emotions,” Colette admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby walked across the room and sat in the chair at the side of the bed. “Okay, baby sister. Want to tell me where the hell you’ve been for the last ten months?” She reached out and took Colette’s hand in hers, her dark blue eyes solemn. “I’ve been worried sick about you since you quit writing to me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Although Colette sensed she could trust this woman with her very life, she found it difficult to confess the depths of her mental confusion. What if she told Abby she had amnesia and Abby tried to take the baby from her? What if it wasn’t really amnesia but some sort of mental illness? And yet, what choice did she have but to tell? With all the blank spots in ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("her mind, there was no way she could pretend everything was all right.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Within minutes she’d told Abby everything she knew, which wasn’t much. Abby asked questions, her hand still holding tight to Colette’s, giving unspoken emotional support and letting Colette know she’d made the right choice in coming here. “I’ll have Doc Washburn give you a full examination, see if there’s any physical reason for your amnesia,” Abby said when Colette had finished explaining everything. “In the meantime, I’ll send for Belinda.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Belinda?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our sister.” She smiled sympathetically at Colette’s frustration. “She’ll be here soon, then we can all powwow under the dragon tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The dragon tree.” Colette looked at Abby. “I remember that…we had a picnic one time beneath the tree.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abby smiled and in her eyes Colette saw pleasant memories and wished she had them, as well. “Every important occasion in our lives was talked about and shared beneath that tree.” She scribbled something on a piece of paper, folded it and stuck it in an envelope. “I’ll send this off tomorrow and by the end of the week Belinda should be here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where is she now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About a year before you decided you wanted to go to California, Belinda decided to try her hand at living on her own in Kansas City. I spoke to her last week and she was between jobs and sounded homesick. I think she’ll welcome a reason to come home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And I was living in California?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Abby nodded. “You moved there about a year and ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("a half ago. You got a job as a paralegal with a big law firm. Until about ten months ago, you wrote regularly, sounded happy and secure. Then your letters stopped coming and your phone was disconnected. My letters started coming back unopened, stamped ‘addressee unknown.’ I’ve been frantic with worry, but didn’t know how to find you. Every day I prayed you’d show up safe and sound.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Again a whisper of fear danced up Colette’s spine. Why had she stopped writing? Why had her phone been disconnected? And what had she been doing in a motel room in Las Vegas? Dammit, why couldn’t she remember? What had happened to steal her memories from her? She looked down at the baby sleeping at her side, the fear no longer a whisper but a shout. “Abby, I think I’m in trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What makes you think that?” Once again Abby sat and reached for her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I—I don’t know. It’s just a feeling I have.” More than a feeling, it was a certain knowledge in her head. “I’m so scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s only natural.” Abby offered her a smile of reassurance. “Honey, you’re suffering a memory loss and that has to be frightening. You’re safe here, and I’m sure it’s just a matter of time before your memory comes back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Abby, do you know who is the father of my baby? Am I married?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Abby squeezed her hand. “I don’t know,” she answered softly. “I don’t know what happened to you in the months we lost contact.” She smiled, but the gesture looked forced. “It will all be okay, Colette.” ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("She released Colette’s hand and stood. “Now, I’ll get out of here and let you get some more sleep.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Colette nodded although she didn’t believe Abby’s words. Nothing was going to be okay. Her fear came from more than her lack of memory, it came from her gut, a visceral terror she couldn’t ignore. When Abby had left the room, Colette snuggled the baby closer to her side, knowing with the instincts of prey that someplace was a hunter, looking for her and her baby.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S THE SUN SET")]), _vm._v(", it lengthened shadows and formed pockets of darkness on the east side of the bunkhouse. A lone figure leaned against the planked wooden building, his gaze focused on the bedroom window where white lace curtains billowed inward with the night breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d known she’d show up here sooner or later. It was the obvious place for her to come. She was smart, she was crafty, but she’d made a big mistake in being predictable and coming home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He scuffed his snakeskin boot against the ground, impatience gnawing inside him, absently tracing the calluses he’d developed in the time he’d been working at the ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been luck that had gotten him hired here a month ago. However, he wouldn’t depend on luck any longer. He had a job to do, and he couldn’t afford to screw up. Too much was at risk. She wouldn’t escape from him again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bce7ee8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781488079085_Chapter_01.vue
// module id = 75
// module chunks = 0